const PromotionApplicationTypeEnum = Object.freeze({
  VARIACAO: 'VARIACAO',
  CATEGORIA: 'CATEGORIA',
  COLECAO: 'COLECAO',
});

export default PromotionApplicationTypeEnum;
